// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hub-action-prompt {
  flex-direction: column;
  align-items: flex-start !important;
}

.hub-action-prompt .header {
  margin: 0 0 1rem !important;
}

.hub-action-prompt .password.prompt .help {
  margin-top: 10px;
}

.hub-action-prompt .redirect.prompt {
  max-width: 100%;
  overflow: hidden;
}

.hub.session .virtual-table,
.hub.session .offline-message,
.hub.session .loader-wrapper {
  flex: 1;
  margin-top: 5px;
}

.hub.session .cell-wrapper.tag,
.hub.session .cell-wrapper.nick,
.hub.session .cell-wrapper.description,
.hub.session .cell-wrapper.share_size {
  overflow: hidden;
  white-space: nowrap;
}

.hub.session .cell-wrapper.nick.op {
  color: steelblue;
}
.hub.session .session-footer .actions-wrapper > a,
.hub.session .session-footer .actions-wrapper > div {
  /* Don't cut the shadow */
  padding-left: 1px;
  padding-bottom: 1px;
}

.hub.session .session-footer #userlist-toggle label {
  color: grey;
  font-size: small;
}

.hub.session .session-footer .actions-wrapper .dropdown {
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Sidebar/routes/Hubs/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,OAAO;EACP,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".hub-action-prompt {\n  flex-direction: column;\n  align-items: flex-start !important;\n}\n\n.hub-action-prompt .header {\n  margin: 0 0 1rem !important;\n}\n\n.hub-action-prompt .password.prompt .help {\n  margin-top: 10px;\n}\n\n.hub-action-prompt .redirect.prompt {\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.hub.session .virtual-table,\n.hub.session .offline-message,\n.hub.session .loader-wrapper {\n  flex: 1;\n  margin-top: 5px;\n}\n\n.hub.session .cell-wrapper.tag,\n.hub.session .cell-wrapper.nick,\n.hub.session .cell-wrapper.description,\n.hub.session .cell-wrapper.share_size {\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.hub.session .cell-wrapper.nick.op {\n  color: steelblue;\n}\n.hub.session .session-footer .actions-wrapper > a,\n.hub.session .session-footer .actions-wrapper > div {\n  /* Don't cut the shadow */\n  padding-left: 1px;\n  padding-bottom: 1px;\n}\n\n.hub.session .session-footer #userlist-toggle label {\n  color: grey;\n  font-size: small;\n}\n\n.hub.session .session-footer .actions-wrapper .dropdown {\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
